import { put } from 'redux-saga/effects'
import { serverRequest } from "../../actions";

export function* reconnect3(action) {
    var payload = {
        action: "portal/setUserPersistentProfile3",
        payload: action.payload,
    };
    yield put(serverRequest(payload));

}


export default reconnect3